<template>
  <div>
    <div id="Chart11" style="width: 100%; height: 250px"></div>
    <div class="chart11_table">
      <table border="1" cellspacing="0">
        <tr>
          <th v-for="(item, index) in table_data" :key="'1' + index">
            {{ item.data1 }}
          </th>
        </tr>
        <tr class="tr2">
          <td v-for="(item, index) in table_data" :key="'2' + index">
            {{ item.data2 }}
          </td>
        </tr>
        <tr class="tr3">
          <td v-for="(item, index) in table_data" :key="'3' + index">
            {{ item.data3 }}
          </td>
        </tr>
        <tr class="tr4">
          <td v-for="(item, index) in table_data" :key="'4' + index">
            {{ item.data4 }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_data: [
        {
          data1: "2011",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2012",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2013",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2014",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2015",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2016",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2017",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2018",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2019",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "2020",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "21Q3",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
        {
          data1: "5年均值",
          data2: "6.92亿",
          data3: "6.92亿",
          data4: "6.92亿",
          data5: "6.92亿",
        },
      ],
    };
  },
  methods: {
    myEcharts11() {
      var myChart11 = this.$echarts.init(document.getElementById("Chart11"));
      //配置图表
      var option11 = {
        tooltip: {
          show: true,
          confine: true, //是否将 tooltip 框限制在图表的区域内4,
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: -40,
          right: -10,
          bottom: 0,
        },
        xAxis: {
          // show: false,
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },

          data: [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "21Q3",
            "5年均值"
          ],
          axisLabel: {
            formatter: function () {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return ``;
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "经营现金流",
            type: "bar",
            data: [60, -72, 71, 74, 190, 130, 110, -123, -21, 389, 265, 124],
            color: "#fcad2a",
            barWidth: 16,
            barGap: "50%",
          },
          {
            name: "投资现金流",
            type: "bar",
            data: [60, 72, 71, 74, 190, 130, 110, 256, 59, 253, 321, 262],
            color: "#539cff",
            barWidth: 16,
            barGap: "50%",
          },
          {
            name: "筹资现金流",
            type: "bar",
            data: [60, -72, -71, 74, 190, 130, 110, 145, -363, -279, 268, 389],
            color: "#fd4c4c",
            barWidth: 16,
            barGap: "50%",
          },
        ],
      };
      myChart11.setOption(option11);
    },
  },
  mounted() {
    this.myEcharts11();
  },
};
</script>

<style scoped>
.chart11_table {
  margin-top: 50px;
}
table {
  border-color: #e9ebf3;
  border-collapse: collapse;
}
th,
td {
  width: 122px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}
th {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
td {
  font-size: 14px;
  color: #fcad2a;
}
.tr2 td {
  color: #fcad2a;
}
.tr3 td {
  color: #539cff;
}
.tr4 td {
  color: #fd4c4c;
}
</style>